import { useMemo } from 'react';
import { useLeague } from '../contexts/LeagueContext';
import { useClerkApi } from './useClerkApi';
import { createLeagueApi, sharedApiBase } from '../utils/api';

// The league's API client: through the share link when the page is a shared
// view (no sign-in), otherwise with the member's Clerk token.
export function useLeagueApi() {
  const { leagueId, season, shareToken } = useLeague();
  const { authFetch } = useClerkApi();
  return useMemo(
    () => (shareToken
      ? createLeagueApi(leagueId, fetch, season, sharedApiBase(shareToken))
      : createLeagueApi(leagueId, authFetch, season)),
    [leagueId, season, shareToken, authFetch],
  );
}
